import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Технический код контроля',
    key: 'ctrl_code',
    width: 250,
    fixedLeft: true,
  },
  {
    title: 'Код контроля',
    key: 'ctrl_ext',
    width: 250,
  },
  {
    title: 'Наименование контроля',
    key: 'ctrl_name',
  },
];
